import React, { FC } from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { useStats } from '../StatsContext';
import { Routes } from '../../../routes';

import styles from './LeaderboardTable.module.scss';

const LeaderboardTable: FC = () => {
  const { leaderboard } = useStats();

  return (
    <div className={styles.leaderboardContainer}>
      <table className={styles.leaderboardTable}>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th className={styles.th}>Zápasy</th>
            <th className={styles.th}>Vítězství</th>
            <th className={styles.th}>Remízy</th>
            <th className={styles.th}>Porážky</th>
            <th className={styles.th}>Skóre</th>
            <th className={clsx(styles.th, styles.points)}>Body</th>
          </tr>
        </thead>
        <tbody>
          {leaderboard.map(({ team, points, wins, draws, losses, rank, scoreFor, scoreAgainst }, index) => (
            <tr key={index} className={styles.teamRow}>
              <td className={clsx(styles.td, styles.rank)}>{rank}.</td>
              <td className={clsx(styles.td, styles.logoCell)}>
                <img
                  src={team.imageStandalone ?? team.image}
                  alt={`${team.name} logo`}
                  width={30}
                  height={30}
                  className={styles.teamLogo}
                />
              </td>
              <td className={clsx(styles.td, styles.teamName)}>
                <Link to={`${Routes['TL25']['routes'][team.route].path}`} className={styles.link}>
                  {team.name}
                </Link>
              </td>
              <td className={clsx(styles.td, styles.stat)}>{wins + draws + losses}</td>
              <td className={clsx(styles.td, styles.stat)}>{wins}</td>
              <td className={clsx(styles.td, styles.stat)}>{draws}</td>
              <td className={clsx(styles.td, styles.stat)}>{losses}</td>
              <td className={clsx(styles.td, styles.stat)}>{`${scoreFor}:${scoreAgainst}`}</td>
              <td className={clsx(styles.td, styles.points)}>{points}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LeaderboardTable;
